export enum MediaType {
  File = 0,
  Image = 1,
  Video = 2,
}
